<template>
    <div class="page-about-companies">
        <div class="companies-desc" v-html="aboutPage.company_desc"></div>
        <div class="companies-cards">
            <div class="card-item" v-for="item in aboutPage.company_cards">
                <div class="item-logo"><img :src="item.logo" alt=""></div>
                <div class="item-info">
                    <div class="in">
                        <strong>{{ item.name }}</strong>
                        <div class="item-desc"><p v-for="desc in item.desc">{{ desc.col }}</p></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'about-page-companies',
        components: {
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - Дочерние компании',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            aboutPage: 'loadAboutPage',
        }),
        methods: {
        },
        beforeCreate() {
            document.body.dataset.page = 'about-companies';
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about-page/companies-section.scss';
    @import '@/styles/components/about-page/respond/companies-section-respond.scss';
</style>